import { lazy, Suspense } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

import MainLayout from 'src/layouts/main';

import { SplashScreen } from 'src/components/loading-screen';

import { mainRoutes } from './main';

const Page404 = lazy(() => import('src/pages/404'));

const HomePage = lazy(() => import('src/pages/home'));

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <MainLayout>
          <Suspense fallback={<SplashScreen />}>
            <HomePage />
          </Suspense>
        </MainLayout>
      ),
    },

    // Main routes
    ...mainRoutes,

    { path: '/404', element: <Page404 /> },

    // No match 404
    { path: '*', element: <Navigate to="/404" replace />, status: 404 },
  ]);
}

